import icon from "./icon.png";
import logo from "./logo.png";

export const Logo = logo;